import React from "react"
import "./UserSummaryCard.scss"
import { imageError } from "../../../services/subscriberService"

const UserSummaryCard = (props) => {
  return (
    <div className={`UserSummaryCard box-layer3${props.me ? " me" : ""}`}>
      <img
        className="UserSummaryCardImage"
        src={props.profile_pic_thumb}
        onError={imageError}
      />
      <p className={`UserSummaryCardName${props.me ? " me" : ""}`}>
        {props.me ? "Me" : props.first_name}
      </p>
      {/* <div className="userSummaryStats">
                <div className="userSummaryRank">
                    <SVG className="userSummaryRankIcon" src={selectIcon('rank_icon')} />
                    <p className={`userSummaryRankText${props.me ? ' me' : ''}`}>{props.rank}</p>
                </div>
                <div className="userSummaryRank">
                    <img className="userSummaryRankIcon" src={selectIcon('calories_icon1')} />
                    <p className={`userSummaryRankText${props.me ? ' me' : ''}`}>{Math.round(props.calories_burnt || 0)}</p>
                </div>
            </div>*/}
    </div>
  )
}

export default UserSummaryCard
